/* eslint-disable no-console */
import axios from 'axios'

const axiosWrap = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL || 'http://localhost:1337',
})

export default axiosWrap
